<app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader>
<div class="former">
    <div class="hall">
        <app-dash-nav></app-dash-nav>
    </div>
    <div class="boxy">
        <div class="headingg container">
            <h2>Idea Name: {{idea_name}}</h2>
        </div>
    </div>
    <form [formGroup]="myForm">
        <div class="container">
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Categories</h3>
            </div>
            <div style="text-align: center;">
                <mat-form-field class="input-field" style="width: 60vw" appearance="outline">
                    <!-- <mat-label class="input-label">Sub-category</mat-label> -->
                    <mat-select [(ngModel)]="form.track" placeholder="Sub-category*" [formControl]="myForm.controls.track">
                      <mat-option *ngFor="let category of category" [value]="category.value">
                          {{ category.viewValue }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field><br>
              </div>
        </div>
    <div class="container" id="1">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Venture Description</h3>
            </div>
        </div>
        <div class="green full">
            <p>
                What problem is your venture targeting to solve? How are the affected people (customers/consumers) coping with the problem at present?
            </p>
            <div class="inputs">
                <div class="field">
                    <editor 
                    [(ngModel)]="form.ques1" [formControl]="myForm.controls.ques1">
                    </editor>
                    <!-- <div class="video">
                        <iframe [src]="safeSrc" width="200" height="200" frameborder="0" webkitallowfullscreen mozallowfullscreen
                        allowfullscreen></iframe>
                    </div> -->
                </div>
                    <button class="green-button" mat-button (click)="onques1()">Save</button>
                    <button (click)="openPopup1()" class="green-button" mat-button>Sample Answer</button>
                </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle1}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup1()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
<p>The sample answer is with respect to Uber taxis</p>
<p>In 2009 it was difficult to find taxis-on-demand in cities. The number of taxis
available on the roads, especially during non-peak hours and late-nights is very few
Drivers usually refuse to drive passengers to their desired destinations, and even if they
do, often demand exorbitant fares.</p>
<p>Uber is an on-demand transportation service. Through a unique business model, the
the venture seeks to bring a revolution in the taxi industry all across the world
Earlier, people had to stand on the street side and wave their hand in order to
signal a taxi to stop. The wait time, the inconvenience and high rates were a problem for
everyone. Quite a few taxis were available and drivers/taxi companies used to charge
whatever they thought was right. There was no control on prices and people were left
with no other option. Apart from this, the situation was worse during peak hours as it was quite
hard to find an empty cab.</p>
                        </div>
                        <div class="container video">
                                        <div class="video">
                                            <!-- <iframe src="https://www.youtube.com/embed/rlPVu0EzGAY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                                    -->
                                        </div>
                                    <!-- </div>
                                        </div> -->
                        </div>
                    </div>
                    <div class="modal-footer">
          
                    </div>
                </div>
            </div>
          </div>
    </div>
    
    
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Venture Description</h3>
            </div>
        </div>
        <div class="green">
            <p>
                What is the current stage of your venture? (Idea stage, Business Model stage, Proof-of-Concept, Client Pilot, Prototyping, Early-stage revenue, Growth-stage, Any Other)
            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques2" [formControl]="myForm.controls.ques2">
                    </editor>
                    <button class="green-button" mat-button (click)="onques2()">Save</button>
                    <button (click)="openPopup2()" class="green-button" mat-button>Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle2}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup2()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="container video">
                                        <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/HTJKD6PzvVE"></iframe>
                                            <!-- <iframe src="https://www.youtube.com/embed/HTJKD6PzvVE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                                        </div>
                                    <!-- </div>
                                        </div> -->
                        </div>
                    </div>
                    <div class="modal-footer">
          
                    </div>
                </div>
            </div>
          </div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Market Analysis</h3>
            </div>
        </div>
        <div class="green">
            <p>
                What is the intended customer segment or target customers of your venture?            
            </p>
            <div class="inputs">
                    <editor 
                    [(ngModel)]="form.ques3" [formControl]="myForm.controls.ques3">
                    </editor>
                    <button class="green-button" mat-button (click)="onques3()">Save</button>
                    <button (click)="openPopup3()" class="green-button" mat-button>Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle3}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup3()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
                            <p><strong>The sample answer is with respect to Uber taxis</strong></p>
                            <p>Customers for Uber are those who:</p>
                            <ul>
                                <li>
                                    <p>Do not own a car.</p>
                                </li>
                                <li>
                                    <p>Do not want to drive themselves to a party or function.</p>
                                </li>
                                <li>
                                    <p>Like to travel in style and want to be treated as a VIP.</p>
                                </li>
                                <li>
                                    <p>Want a cost-efficient cab at their doorstep.</p>
                                </li>
                            </ul>
                            <p>Uber has such a vast customer segment that it has got something to offer for everyone. From Uber Taxis to Uber Black and from UberX to Uber SUV, the company has got a vast range for its customers to make a choice. Uber serves professionals as they hire an Uber cab to and fro work. For this Uber did few tie-ups with corporates in the beginning and does so when it launches in a new city in a new country. Apart from professionals, Uber tries to personally connect with its customers by offering special services like:</p>
                            <p>Uber for Kids: A special service from Uber dedicated to parents who want their kids to reach home from school in an Uber cab.</p>
                            <p>Uber for Senior Citizens: Another special service from Uber where it targets senior citizens. As per the statistics, Senior citizens make for up to 30% to 40% of total rides in many cities. This made Uber have some special features for seniors and hence attract more senior citizens to the platform.</p>
                        </div>
                        <div class="container video">
                                        <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/wWpEiSKeDDo"></iframe>
                                        </div>
                        </div>
                    </div>
                    <div class="modal-footer">
          
                    </div>
                </div>
            </div>
          </div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>VCompetitor Analysis</h3>
            </div>
        </div>
        <div class="green">
            <p>
                Who are your current competitors? (Please mention both direct and indirect competitors if applicable)            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques4" [formControl]="myForm.controls.ques4">
                    </editor>
                    <button class="green-button" mat-button (click)="onques4()">Save</button>
                    <button (click)="openPopup4()" class="green-button" mat-button>Sample Answer</button>

            </div>
            <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle4}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content  mode">
                        <div class="modal-header">
                          <div style="float:right; color:white;">
                            <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup4()">
                          </div>
                            <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                        </div>
                        <div style="color: white;">
                            <div class="member" style="color: white;">
                                <p><strong>The sample answer is with respect to Uber taxis</strong></p>
                                <ul>
                                    <li>Black &amp; Yellow cabs</li>
                                    <li>Private Cab</li>
                                    <li>Rent-a-Car Services(Avis, Hertz, etc.)</li>
                                </ul>
                            </div>
                            <div class="container video">
                                            <div class="video">
                                                <iframe width="300" src="https://www.youtube.com/embed/C91utiNU0cI"></iframe>
                                            </div>
                            </div>
                        </div>
                        <div class="modal-footer">
              
                        </div>
                    </div>
                </div>
              </div>
        </div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Revenue Model</h3>
            </div>
        </div>
        <div class="green">
            <p>
                How will your venture generate revenue? What are the factors affecting your costs and revenues? Also highlight any growth opportunities in future.            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques5" [formControl]="myForm.controls.ques5">
                    </editor>
                    <button class="green-button" mat-button (click)="onques5()">Save</button>
                    <button class="green-button" mat-button (click)="openPopup5()">Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle5}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup5()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
                            <p><strong>The sample answer is with respect to Uber taxis</strong></p>
                            <p>Different cab models to cater to everyone. Uber has not limited itself to a particular segment of cars or to a particular segment of people. There is UberX, Uber Black for those who love to travel in a black car, Uber Taxi for those looking for cost-efficient solutions and Uber SUV for those who want luxury.</p>
                            <p><strong>Surge Pricing Technology:</strong></p>
                            <p>Variation in cab fares according to the situation is an important aspect of Uber&rsquo;s business model. Whenever the demand increases, per mile prices, are automatically increased. The new price depends on the number of available drivers and the number of requests made by people who want to travel. Uber has applied for a price surge technology patent in the US.</p>
                            <p><strong>Other Uber rides:</strong></p>
                            <p>Uber has come a long way from cabs. It now offers boats, helicopters as well as some other transportation means on-demand. Uber recently launched a motorcycle-pickup service in Paris, a delivery service in San Francisco, and an ice-cream-truck-delivery service in 7 other cities. However, these means are available in selected geographical locations but it has led Uber to add new streams of revenue into its business model.</p>
                            <p>Uber charges a percentage of the fare earned from each ride collected from the passenger and passes on the balance(75-80%) to the owner-driver.</p>
                            <p>The factors affecting your costs and revenues</p>
                            <p>Cost Factors: Technology</p>
                            <p>Revenues: Demand for taxis level of economic activity</p>
                            <p><br></p>
                        </div>
                        <div class="container video">
                                        <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/Y2-5aPewZCA"></iframe>
                                        </div>
                        </div>
                    </div>
                    <div class="modal-footer">
          
                    </div>
                </div>
            </div>
          </div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Unique Selling Proposition (USP)</h3>
            </div>
        </div>
        <div class="green">
            <p>
                How does your idea and marketing strategy differentiate your startup from your competitors and help you create demand for your product/service? Mention your IP (Intellectual Property) advantage if any.            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques6" [formControl]="myForm.controls.ques6">
                    </editor>
                    <button class="green-button" mat-button (click)="onques6()">Save</button>
                    <button class="green-button" mat-button (click)="openPopup6()">Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle6}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup6()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
                            <p><strong>The sample answer is with respect to Uber taxis</strong></p>
                            <p><strong>Customers:</strong></p>
                            <ul>
                                <li>No need to wait for a taxi for a long time.</li>
                                <li>Free rides on certain occasions and discounts from time to time.</li>
                                <li>Prices are less than the normal taxi fares.</li>
                                <li>Uber&rsquo;s tagline says &ndash; Your personal driver. It lets customers travel in style.</li>
                                <li>Fixed prices for common places like airports etc.</li>
                            </ul>
                            <p><strong>Drivers:</strong></p>
                            <ul>
                                <li>An additional source of income.</li>
                                <li>Flexible working schedules. Can work part-time or simply whenever they like.</li>
                                <li>Easy payment procedure.</li>
                                <li>Those who love to drive can earn money while pursuing their hobby.</li>
                                <li>Uber pays drivers to be online, even if they don&rsquo;t get any requests.</li>
                            </ul>
                            <p><br></p>
                            <p><br></p>
                        </div>
                        <div class="container video">
                                        <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/rlPVu0EzGAY"></iframe>
                                        </div>
                        </div>
                    </div>
            </div>
          </div></div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>Impact</h3>
            </div>
        </div>
        <div class="green">
            <p>
                What is the Impact of the innovation on (i) India’s competitiveness (ii) Society (iii) Employment and (iv) Environment8            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques8" [formControl]="myForm.controls.ques8">
                    </editor>
                    <button class="green-button" mat-button (click)="onques8()">Save</button>
                    <button class="green-button" mat-button (click)="openPopup8()">Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle8}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup8()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
                            <p>There is no sample response for this question</p>
                        </div>
                        <div class="container video">
                                        <!-- <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/C91utiNU0cI"></iframe>
                                        </div> -->
                        </div>
                    </div>
            </div>
          </div></div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>General</h3>
            </div>
        </div>
        <div class="green">
            <p>
                What are the significant scientific & technical challenges in scaling up and commercialization?
            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques9" [formControl]="myForm.controls.ques9">
                    </editor>
                    <button class="green-button" mat-button (click)="onques9()">Save</button>
                    <button class="green-button" mat-button (click)="openPopup9()">Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle9}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup9()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
                            <p>There is no sample response for this question</p>
                        </div>
                        <div class="container video">
                                        <!-- <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/C91utiNU0cI"></iframe>
                                        </div> -->
                        </div>
                    </div>
            </div>
          </div></div>
    </div>
    <div class="container">
        <div>
            <div class="description">
                <img class="pin" src="https://eureka2022.s3.ap-south-1.amazonaws.com/pin.png" alt="">
                <h3>General</h3>
            </div>
        </div>
        <div class="green">
            <p>
                Add the website link of your Startup(If any)            </p>
            <div class="inputs">
                
                    <editor 
                    [(ngModel)]="form.ques7" [formControl]="myForm.controls.ques7">
                    </editor>
                    <button class="green-button" mat-button (click)="onques7()">Save</button>
                    <button class="green-button" mat-button (click)="openPopup7()">Sample Answer</button>
            </div>
        </div>
        <div style="    z-index: 2" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle7}">
            <div class="modal-dialog" role="document">
                <div class="modal-content  mode">
                    <div class="modal-header">
                      <div style="float:right; color:white;">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png" alt="close" (click)="closePopup7()">
                      </div>
                        <h1 style="display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;" class="modal-title"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">SAMPLE ANSWER</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
                    </div>
                    <div style="color: white;">
                        <div class="member" style="color: white;">
                            <p>There is no sample response for this question</p>
                        </div>
                        <div class="container video">
                                        <!-- <div class="video">
                                            <iframe width="300" src="https://www.youtube.com/embed/C91utiNU0cI"></iframe>
                                        </div> -->
                        </div>
                    </div>
            </div>
          </div></div>
    </div>

    <div class="center">
        <button class="btn inverse" mat-button (click)="onsubmit()">Submit</button>
    </div>

</form>
</div>

<!-- MODAL2 -->
<!--   ADD TEAM MEMBER    -->


